export default __webpack_public_path__ + "static/media/SFONDO-NFT-NOT-FOUND.d3cfa50b.png";